// extracted by mini-css-extract-plugin
export default {"container":"info_entry_container__XwHkV","label":"info_entry_label__qmYW1","content":"info_entry_content__4eKB+"};